<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="900px">
    <template v-slot:title>Add Route</template>
    <template v-slot:top>
      <v-container fluid pb-0>
        <v-row align="center" justify="center" dense>
          <v-col cols="12" sm="10" class="pb-0">
            <v-text-field
              label="Filter"
              v-model="search"
              :outlined="outlinedInputs"
              dense
              class="ma-0"
              append-icon="mdi-magnify"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
          <v-col v-if="false">
            <v-btn
              :loading="uploading"
              :disabled="uploading"
              color="blue-grey"
              class="ma-2 white--text"
              @click="onUpload"
            >
              Upload
              <v-icon right dark>mdi-cloud-upload</v-icon>
            </v-btn>
            <input
              ref="fileChooser"
              accept=".csv,.kml"
              type="file"
              style="display: none"
              @change="onFileChange"
            />
          </v-col>
        </v-row>
      </v-container>
    </template>
    <v-card outlined>
      <v-data-table
        :items="routes"
        :headers="headers"
        :search="search"
        v-model="selectedRoutes"
        show-select
        single-select
        :loading="$apollo.loading"
      >
      </v-data-table>
    </v-card>
    <div v-if="debug">{{}}</div>
    <template v-slot:actions>
      <v-btn
        color="primary"
        :disabled="selectedRoutes.length == 0"
        @click="onAdd"
        >Add</v-btn
      >
    </template>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../../shared/BasicDialog";
import { GET_FB_TOKEN_QUERY } from "../../../../../constants/graphql";
import * as fb from "../../../../../constants/gt-routes-firebase";

export default {
  name: "routes-dialog",

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
  },

  components: { BasicDialog },

  data() {
    return {
      debug: false,
      routes: [],
      search: "",
      selectedRoutes: [],
      uploading: false,
      headers: [
        {
          text: "Name",
          sortable: false,
          value: "name",
          name: "name",
        },
        {
          text: "Status",
          sortable: false,
          value: "status",
          name: "status",
        },
        {
          text: "Tags",
          sortable: false,
          value: "tags",
          name: "tags",
        },
      ],
    };
  },

  computed: {
    fbToken() {
      return this.gtRoutesFbToken ? this.gtRoutesFbToken : "notoken";
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  methods: {
    getRoutes() {
      fb.routesCollection
        .where("uid", "==", fb.auth.currentUser.uid)
        .orderBy("created", "desc")
        .onSnapshot((snapshot) => {
          let routes = [];

          snapshot.forEach((doc) => {
            let route = doc.data();
            route.id = doc.id;
            route.code = doc.id;
            routes.push(route);
          });

          this.routes = [...routes];
        });
    },
    async onAdd() {
      const selectedRoute = this.selectedRoutes[0];
      const pois = await this.getPois(selectedRoute.id);
      this.$emit("create", { ...selectedRoute, pois });
    },
    async getPois(id) {
      const snapshot = await fb.routesCollection
        .doc(id)
        .collection("pois")
        .get();
      return snapshot.docs.map((doc) => {
        const { type, ...poi } = doc.data();
        return { ...poi, typeId: type.id };
      });
    },
    onUpload() {
      console.log("uploading file");
      this.$refs.fileChooser.click();
    },
    onFileChange(event) {
      //console.log(event, );
      if (this.$refs.fileChooser.files.length > 0) {
        this.uploading = true;
        const file = this.$refs.fileChooser.files[0];
        const filename = file.name;
        console.log(filename);
        const fileRef = fb.routesStorage.child(
          `${fb.auth.currentUser.uid}_${filename}`
        );
        // //console.log($user);
        fileRef
          .put(file)
          .then((snapshot) => {
            console.log("Uploaded file!", snapshot);
            this.uploading = false;
          })
          .catch((error) => console.log(error));
      }
    },
    onViewItem(item) {
      console.log("viewing item", item);
    },
  },

  apollo: {
    gtRoutesFbToken: {
      query: GET_FB_TOKEN_QUERY,

      result({ data }) {
        //authorize and get routes list

        if (!fb.auth.currentUser) {
          const token = data.gtRoutesFbToken;
          console.log("signin with token");
          fb.auth
            .signInWithCustomToken(token)
            .then((res) => {
              console.log("I am in", res);
            })
            .catch((err) => console.log("Sign in error:", err));
        } else {
          this.getRoutes();
        }
      },
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/routes/fb/RoutesDialog.vue